import { RiskRating } from '../constants/riskRating';

// Reverse lookup from the numeric rating enum to its letter, e.g. { 0: 'A', 3: 'D' }.
// Built from RiskRating so any rating added to the enum is mapped automatically.
const ratingKeyByValue = Object.fromEntries(
	Object.entries(RiskRating).map(([key, value]) => [value, key])
);

export const getRiskRatingKey = (rate) => ratingKeyByValue[rate] ?? '';
